import { apiClient } from './apiClient';

export interface DashboardStats {
  vessels: number;
  voyages: number;
  charterers: number;
  contracts: number;
  invoices: number;
  procurements: number;
  entities: number;
}

export const DashboardService = {
  async getDashboardStats(userId?: string): Promise<DashboardStats> {
    const url = userId
      ? `/dashboard/stats?userId=${encodeURIComponent(userId)}`
      : '/dashboard/stats';
    return apiClient.get<DashboardStats>(url);
  },
};
